





















import Vue, { PropType } from 'vue'
import { DashboardTemplate } from '../../base/store/state.interface'
import BaseDialog from './BaseDialog.vue'

export default Vue.extend({
  components: {
    BaseDialog
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    template: {
      type: Object as PropType<DashboardTemplate>,
      required: true,
      default: () => new Object()
    }
  },
  data() {
    return {
      layoutName: ''
    }
  },
  methods: {
    deleteDashboard() {
      this.$emit('deleteDashboard', this.template)
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
})
